import { FOfferType } from '../../../../utils/offer_type';

export function getSpecialtyTitle(offerType: FOfferType) {
  return offerType === FOfferType.Business ? 'Сфера деятельности: ' : 'Возможное назначение';
}
